// extracted by mini-css-extract-plugin
module.exports = {"close":"SearchInput_close__GIVn6","input":"SearchInput_input__toBnH","wrapper":"SearchInput_wrapper__1RIB_"};